// extracted by mini-css-extract-plugin
export var avatar = "_nh-3";
export var avatarContainer = "_nh-2";
export var avatarSpacer = "_nh-5";
export var avatarSpacerContainer = "_nh-4";
export var avatarStackContainer = "_nh-1";
export var bubble = "_nh-0";
export var remainderBubble = "_nh-6";